import { React, useEffect, useState } from "react";
import axios from "axios";
import { FacultyTable, FacultyCreate } from "..";
import SearchIcon from "@mui/icons-material/Search";


function FacultySearch() {
  const [facultyName, setFacultyName] = useState("");

  const [faculties, setFaculties] = useState([]);

  const [updateTable, setUpdateTable] = useState(false);

  useEffect(() => {
    showFacultySearchResults();
  }, [facultyName, updateTable]);

  const showFacultySearchResults = () => {
    const body = new FormData();
    body.append("facultyName", facultyName);
    axios.post("/faculty/searchFaculties", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setFaculties(data.faculties);
      } else {
      }
    });
  };

  const resetHooks = () => {
    setFacultyName("");
  };

  return (
    <div className="FacultySearch bg-brand-tertiary h-full">
      <div className="FacultySearch-container flex flex-col p-8 h-full">
        <div className="FacultySearch-topContainer flex flex-wrap">
          <div className="FacultySearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={facultyName}
              onChange={(e) => setFacultyName(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <FacultyCreate updateTable={updateTable} setUpdateTable={setUpdateTable} />

          <button type="button"
            className="FacultySearch-resetButton search-button px-4 h-11 mb-4 text-center py-2" onClick={resetHooks}>
            Reset Search
          </button>
        </div>
        <div className="FacultySearch-bottomContainer flex w-full h-full">
          <FacultyTable faculties={faculties} updateTable={updateTable} setUpdateTable={setUpdateTable} />
        </div>
      </div>
    </div>
  );
}

export default FacultySearch;
